import { z } from 'zod'

export const ErpCustomerDiscountCodeSchema = z.object({
  code: z.string(),
  group: z.string().nullish(),
  description: z.string().nullish(),
  expiration_date: z.string().optional(),
})

export type ErpCustomerDiscountCode = z.infer<
  typeof ErpCustomerDiscountCodeSchema
>
